import { createSelector } from 'reselect'
import { pickBy, sortBy, values, compact, keys } from 'lodash'
import moment from 'moment'

import { groupCountBy, str2moment } from '../../lib/Tools'
import { getStatusName, getStatusValue, getTripTab } from '../trips/TripStatus.js'
import filterTrips from '../trips/filterTrips'

import { getIdFromUrl } from './auxiliary'
import { getTripBill } from '../../lib/TripTools'


/**
 * trips
 */
export const getAllTrips = (state, props) => state.trips
const getTripsArray = (state, props) => values(state.trips).filter(t => !t.deleted)
const getUsernameProp = (state, props) => props.username

const getQueryProp = (state, props) => props.query || {}

const getUsername = (state, props) => state.loginData.username


export const getTrips = createSelector(
  [getAllTrips], 
  trips => pickBy(trips, t => !t.deleted) 
)

// trips que a) tengan pagos, y b) sean de desde hace 6 meses
export const getTripsWithPayments = createSelector(
  [getTrips],
  trips => {
    // esto se repite en el aviso en AllPayments
    const cut = moment().startOf("day").subtract(6, "months")
    return values(trips).filter(trip => (
      trip.payments.length > 0 && str2moment(trip.endDate || trip.startDate).isAfter(cut)
    ))
  }
)

export const getTripsList = createSelector([getTrips], T => sortBy(values(T), t => t.status))

/**
 * OperPage list
 */

export const getFilteredTripsList = createSelector(
  [getTripsArray, getUsername, getQueryProp], 
  (trips, username, query) => filterTrips(compact(trips), username, query)
)

const getFilteredTripsListAllTabs = createSelector(
  [getTripsArray, getUsername, getQueryProp], 
  (trips, username, query) => filterTrips(compact(trips), username, { ...query, tab: "all" })
)

export const getTripCountPerTab = createSelector(
  [getTripsArray], 
  trips => groupCountBy(trips, getTripTab)
)

export const getFilteredTripCountPerTab = createSelector(
  [getFilteredTripsListAllTabs], 
  trips => groupCountBy(trips, getTripTab)
)

/**
 * 
 */

export const getTripForUrl = createSelector(
  [getIdFromUrl, getAllTrips], 
  (id, trips) => trips[id]
)

export const getUserTripsList = createSelector(
  [getTrips, getUsernameProp], 
  (trips, username) => values(trips).filter(trip => trip.encargado === username)
) 

export const getUsersPendingTrips = createSelector(
  [getUserTripsList],
  trips => sortBy(trips.filter(trip => trip.status < getStatusValue("bond_sent")),
                  trip => trip.status)
)

/**
 * report
 */

export const makeFilterTripsReport = createSelector(
  [getTrips], 
  T => options => {
    const filterDate = moment(options.date.replace(/\//g, "-"))
    const startDate = moment(options.startDate.replace(/\//g, "-"))
    const endDate = moment(options.endDate.replace(/\//g, "-"))

    return (
      keys(T).filter(tk => {
        const thisStatus = getStatusName(T[tk].status)
        return options[thisStatus]
      })
      .filter(tk => (
        (!options.dateFilter || moment(T[tk].creation).isSameOrAfter(filterDate))
        && 
        (!options.twoDatesFilter 
          || (moment(T[tk].creation).isSameOrAfter(startDate) 
            && moment(T[tk].creation).isSameOrBefore(endDate)))
      ))
      .map(tk => T[tk])
    )
  }
)

/**
 * bill
 */

const ownTrip = (state, ownProps) => ownProps.trip
const activities = state => state.activities
const cities = state => state.cities
const routes = state => state.routes

export const getBillForProps = createSelector(
  [ownTrip, activities, cities, routes], 
  (t, a, c, R) => {
    const r = t ? R[t.mainRoute] : null
    return t ? getTripBill(t, r, a, c) : []
  })

